import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { Button } from './ui/button';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(true);
  const whatsappNumber = '41784417112';

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${whatsappNumber}?text=Hallo,%20ich%20möchte%20ein%20Fixpreis-Angebot%20für%20Malerarbeiten%20anfragen.`, '_blank');
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-fade-in">
      <Button
        onClick={handleWhatsApp}
        size="lg"
        className="bg-green-600 hover:bg-green-700 text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-110 p-4 w-16 h-16 flex items-center justify-center group"
      >
        <MessageCircle className="w-8 h-8 group-hover:scale-110 transition-transform" />
      </Button>
      <div className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 rounded-full animate-pulse"></div>
    </div>
  );
};

export default WhatsAppButton;